import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ContainerBuiltInControl} from '../ContainerBuiltInControl';

export abstract class ContainerBackgroundColorBuiltInControl extends ContainerBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.CONTAINER].BACKGROUND_COLOR;
  }
}
